import { render, staticRenderFns } from "./FilerScreensNav.vue?vue&type=template&id=6c874fb2&"
import script from "./FilerScreensNav.vue?vue&type=script&lang=js&"
export * from "./FilerScreensNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports